import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { ParamUrlService } from '@service/paramurl.service';
import { CommonService } from '@service/common.service';

export const LoginGuardService: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const paramUrlService = inject(ParamUrlService);
    const commonService = inject(CommonService);

    let wUrlParam = '';
    let wContent: [];
    let wParams: any;
    let wDefpage = '';

    const wRes = await auth.isAuthenticated();
    if (wRes) {
        if (commonService.resetPass === true) {
            await router.navigate(['page-reset-pwd']);
        } else {
            wParams = route.queryParams;
            wContent = await paramUrlService.getContent(route.queryParams['Content']);
            wDefpage = paramUrlService.getDefaulPage();
            if (wContent.length === 0) {
                wUrlParam = paramUrlService.getPageFromUrl(route.queryParams['search'], wDefpage);
            } else {
                wUrlParam = paramUrlService.getPageFromUrl(wContent['search'], wDefpage);
                wParams = wContent;
            }
            if (wUrlParam !== '') {
                paramUrlService.getRestricted(wParams);
                paramUrlService.getRequestParams(wUrlParam, wParams);
                await router.navigate([wUrlParam]);
            } else {
                await router.navigate(['dashboard']);
            }
        }
        return false;
    } else {
        auth.clearStorage();
    }
    return true;
};